"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgPlayCircular = function (_a) {
    var primaryColor = _a.primaryColor, secondaryColor = _a.secondaryColor, tertiaryColor = _a.tertiaryColor, props = __rest(_a, ["primaryColor", "secondaryColor", "tertiaryColor"]);
    return (react_1.default.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 56 57" }, props),
        react_1.default.createElement("g", { filter: "url(#PlayCircular_svg__a)" },
            react_1.default.createElement("path", { fill: primaryColor, d: "M56 28.25c0 15.464-12.536 28-28 28s-28-12.536-28-28 12.536-28 28-28 28 12.536 28 28Z" }),
            react_1.default.createElement("path", { stroke: secondaryColor, strokeOpacity: 0.95, strokeWidth: 1.25, d: "M55.375 28.25c0 15.119-12.256 27.375-27.375 27.375S.625 43.37.625 28.25 12.881.875 28 .875 55.375 13.131 55.375 28.25Z" })),
        react_1.default.createElement("path", { fill: secondaryColor, fillOpacity: 0.95, d: "M38 26.518c1.333.77 1.333 2.694 0 3.464l-13.5 7.794c-1.333.77-3-.192-3-1.732V20.456c0-1.54 1.667-2.502 3-1.732L38 26.518Z" }),
        react_1.default.createElement("defs", null,
            react_1.default.createElement("filter", { id: "PlayCircular_svg__a", width: 72, height: 72, x: -8, y: -7.75, colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
                react_1.default.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
                react_1.default.createElement("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: 4 }),
                react_1.default.createElement("feComposite", { in2: "SourceAlpha", operator: "in", result: "effect1_backgroundBlur_289_1077" }),
                react_1.default.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_backgroundBlur_289_1077", result: "shape" })))));
};
exports.default = SvgPlayCircular;
